<template>
  <v-container class="ma-0">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          class="ma-0"
          fab
          dark
          small
          color="green"
          v-bind="attrs"
          v-on="on"
          @click="importExcel"
          :loading="loading"
        >
          <v-icon dark>mdi-package-up</v-icon>
        </v-btn>
      </template>
      <span>Import</span>
    </v-tooltip>
    <alert-success
      :toggle-dialog="success"
      title="Import Success"
      message="Data was imported successfully"
    />
    <alert-error
      :toggle-dialog="error"
      title="Import Error!"
      :message="errorMessage"
    />
  </v-container>
</template>
<script>
  import readExcel from '@/extra-functions/readExcel.extra'
  import { mapState } from 'vuex'
  import stockRepository from '@/repositories/stock.repository'
  import indexKeyGenerator from '@/extra-functions/index-key-generator.extra'
  import { dateFormatMixin } from '@/views/dashboard/mixins/helper.mixins'
  import searchDelay from '@/extra-functions/searchDelay.extra'
  import { errorHandler } from '@/extra-functions/store.extra'

  const errorDelay = searchDelay(100)
  const successDelay = searchDelay(100)
  const { dialog } = require('electron').remote
  export default {
    name: 'import-stock',
    components: {
      alertSuccess: () => import('@/views/dashboard/components/AlertSuccess'),
      alertError: () => import('@/views/dashboard/components/AlertError'),
    },
    data () {
      return {
        loading: false,
        success: false,
        errorMessage: [],
        error: false,
      }
    },
    computed: {
      ...mapState({
        storeId: state => state.settings.storeId,
      }),
    },
    methods: {
      importExcel () {
        const options = {
          title: 'Import',
          filters: [{ name: 'Excel', extensions: ['xlsx'] }],
          buttonLabel: 'import',
        }
        dialog.showOpenDialog(null, options)
          .then(({ canceled, filePaths }) => {
            if (!canceled) {
              this.readExcel(filePaths[0])
            }
          })
      },
      async readExcel (filePath) {
        readExcel.loadExcel(filePath, this.importExcelFile)
      },
      importExcelFile (excelData) {
        this.errorMessage = []
        if (!this.loading) {
          this.loading = true
          const data = this.finalizeData(excelData)
          stockRepository.importExcel(data)
            .then(() => {
              this.success = true
              successDelay(() => { this.success = false })
            })
            .catch(e => {
              this.error = true
              errorDelay(() => { this.error = false })
              this.errorMessage = errorHandler(e)
            })
            .then(() => { this.loading = false })
        }
      },
      finalizeData (data) {
        return data.map(e => {
          return {
            ...e,
            id: indexKeyGenerator(),
            store_id: this.storeId,
          }
        })
      },
    },
    mixins: [
      dateFormatMixin,
    ],
  }
</script>
